import { useQuery } from "@tanstack/react-query";

import { layoutQuery } from "../infra/layout.query";

export const useLayout = (id: string) => {
  const { data, ...rest } = useQuery({ ...layoutQuery(id) });

  return { layout: data, ...rest };
};
